<template>
    <span :style="[cssProps,cssStyle]" :class="['new-tab-tag', forceBol ? 'force-bol' : '']">
        <span class="new-tag-content">Nova</span>
    </span>
</template>
<script>
export default {
    name: 'EgNewTag',
    props: {
        marginLeft: {
            default: false,
            type: [Boolean, String]
        },
        forceBol: {
            default: false,
            type: Boolean
        },
        cssStyle: {
            default: ()=>{},
            type: Object
        }
    },
    data: () => ({
        isMobile: false
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            // this.checkBolAction();
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    // methods: {
    //     checkBolAction() {
    //         if () {
    //             console.log('aqui mesmo');
    //             document.getElementById('new-tab-tag').innerHTML = '';
    //         } else {
    //             document.getElementById('new-tab-tag').innerHTML = 'Nova';
    //         }
    //     }
    // },
    computed: {
        cssProps() {
            return {
                ...this.cssStyle,
                '--marginLeft': this.marginLeft ? this.marginLeft : '10px',
                '--newTagContent': this.isMobile || this.forceBol ? 'hidden' : 'unset',
            };
        }
    }
};
</script>
<style scoped lang="scss">
.new-tag-content{
    visibility: var(--newTagContent);
}
.new-tab-tag {
    background-color: #ed4f4f;
    color: #fff;
    padding-top: 1px;
    padding-bottom: 1px;
    padding-inline: 8px;
    border: 1px solid #ed4f4f;
    border-radius: 37px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    margin-left: var(--marginLeft);
}
.force-bol {
    margin-left: var(--marginLeft);
    height: 10px !important;
    width: 10px !important;
    border-radius: 42px !important;
    padding-inline: 0px !important;
}
@media screen and (max-width: 768px) {
    .new-tab-tag {
        margin-left: 3px;
        height: 10px;
        width: 10px;
        border-radius: 42px;
        padding-inline: 0px;
    }
}
</style>
